import React from 'react';
import ReactDom from 'react-dom';

import App from './layout/MainLayout';
import * as serviceWorker from './serviceWorker';

import './index.css';
import './Highlight.css';

ReactDom.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
